import React from 'react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const MOSS   = '#3B6B44';
const OCHRE  = '#A6752A';
const RUST   = '#A13D2D';
const STONE  = '#8C8275';
const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const STATUS_FILTERS = [
  { id: 'all',                  label: 'All Stages', color: STONE },
  { id: 'sold',                 label: 'Sold',        color: OCHRE },
  { id: 'awaiting_production',  label: 'Awaiting',    color: STONE },
  { id: 'in_production',        label: 'In Prod',     color: OCHRE },
  { id: 'ready_for_install',    label: 'Ready',        color: MOSS },
  { id: 'ready_for_pickup',     label: 'Pickup',       color: MOSS },
  { id: 'scheduled',            label: 'Scheduled',  color: WALNUT },
  { id: 'on_hold',               label: 'On Hold',     color: RUST },
  { id: 'completed',            label: 'Completed',   color: MOSS },
  { id: 'cancelled',            label: 'Cancelled',   color: RUST }
];

export default function StatusFilters({ selected, onChange, showRepairsOnly, onRepairsToggle }) {
  return (
    <div style={{ fontFamily: FONT_SANS }}>
      {/* Status Pills */}
      <div style={{
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
        marginBottom: '12px'
      }}>
        {STATUS_FILTERS.map(filter => {
          const isSelected = selected === filter.id;

          return (
            <button
              key={filter.id}
              onClick={() => onChange(filter.id)}
              style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                padding: '7px 14px',
                background: isSelected ? `${filter.color}14` : 'transparent',
                border: `1.5px solid ${isSelected ? filter.color : 'rgba(139,69,19,0.15)'}`,
                borderRadius: '20px',
                fontSize: '12px',
                fontWeight: '600',
                fontFamily: FONT_SANS,
                color: isSelected ? filter.color : STONE,
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = filter.color;
                  e.currentTarget.style.background = `${filter.color}0d`;
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = 'rgba(139,69,19,0.15)';
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: filter.color, flexShrink: 0 }} />
              {filter.label}
            </button>
          );
        })}
      </div>

      {/* Repairs Toggle */}
      <label style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
        color: INK,
        cursor: 'pointer',
        userSelect: 'none'
      }}>
        <input
          type="checkbox"
          checked={showRepairsOnly}
          onChange={(e) => onRepairsToggle(e.target.checked)}
          style={{
            width: '16px',
            height: '16px',
            cursor: 'pointer',
            accentColor: WALNUT
          }}
        />
        <span>Repairs only</span>
      </label>

      <div style={{
        fontSize: '11px',
        color: STONE,
        marginTop: '8px'
      }}>
        Filters apply to all job lists below
      </div>
    </div>
  );
}
